<template>
    <div class="flex-1" :class="index > 0 ? 'border-t border-gray-400 pt-8 mt-8' : 'mt-3'">
        <div class="flex flex-col sm:flex-row -mt-4">
            <div class="sm:col-gap-1 flex-1 my-1">
                <input
                    type="hidden"
                    :name="'contacts[seller_broker][' + index + '][id]'"
                    :value="contact.id"
                />

                <input
                    type="hidden"
                    :name="'contacts[seller_broker][' + index + '][user_id]'"
                    :value="contact.user_id"
                />

                <input-text
                    label="Name"
                    :name="'contacts[seller_broker][' + index + '][name]'"
                    v-model="contact.name"
                    placeholder="Name"
                    :read_only="read_only"
                />
            </div>

            <div class="sm:col-gap-1 flex-1 my-1">
                <input-text
                    label="E-Mail"
                    :name="'contacts[seller_broker][' + index + '][email]'"
                    v-model="contact.email"
                    placeholder="E-Mail"
                    :read_only="read_only"
                />
            </div>

            <div class="sm:col-gap-1 flex-1 my-1">
                <input-text
                    label="Phone"
                    :name="'contacts[seller_broker][' + index + '][phone]'"
                    v-model="contact.phone"
                    placeholder="Phone"
                    :read_only="read_only"
                />
            </div>
        </div>

        <div class="flex flex-col sm:flex-row mt-8 sm:mt-4">
            <div class="sm:col-gap-1 flex-1 my-1">
                <input-text
                    label="Agent ID"
                    :name="'contacts[seller_broker][' + index + '][external_id]'"
                    v-model="contact.external_id"
                    placeholder="#"
                    :read_only="read_only"
                />
            </div>

            <div class="sm:col-gap-1 flex-1 my-1">
                <input-text
                    label="Office Name"
                    :name="'contacts[seller_broker][' + index + '][company]'"
                    v-model="contact.company"
                    placeholder="Name"
                    :read_only="read_only"
                />
            </div>

            <div class="sm:col-gap-1 flex-1 my-1">
                <input-text
                    label="Office ID"
                    :name="'contacts[seller_broker][' + index + '][company_external_id]'"
                    v-model="contact.company_external_id"
                    placeholder="#"
                    :read_only="read_only"
                />
            </div>
        </div>

        <div
            v-if="! read_only && count > 1"
            class="cursor-pointer flex hover:text-red-600 items-center justify-end pt-4 text-gray-400"
            @click="deleteBroker"
        >
            <i class="fas fa-minus-circle"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contact: { default: () => ({}) },
        broker: { default: () => ({}) },
        read_only: { default: false },
        index: { default: 0 },
        count: { default: 0 },
    },

    computed: {
        our_sale() {
            return store.state.our_sale;
        },
    },

    methods: {
        deleteBroker() {
            this.$emit('delete', this.contact.id || this.contact.key);
        },
    },
}
</script>
